




import { Component, Vue, Prop } from 'vue-property-decorator';
import { CourseChange } from '@/domains/course';

@Component({ name: 'CourseChangeButton' })
export default class CourseChangeButton extends Vue {
  /** 表单 */
  @Prop({ default: (): CourseChange[] => [] })
  private list: CourseChange[];

  /** bus */
  @Prop()
  private bus: Vue;

  /** 禁用 */
  get disable() { return this.list.length <= 0; }

  /** 按钮类型 */
  get type() { return this.disable ? 'info' : 'danger'; }

  /** 点击事件 */
  private click() {
    this.bus.$emit('course-change-dialog', this.list);
  }
}
